import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Button} from '../../atoms/Buttons/Button';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {ProductCardProps} from './ProductCard';
import {ProductCardBase} from './ProductCardBase';
import {ProductCardDescription} from './ProductCardDescription';
import {ProductCardImage} from './ProductCardImage';

interface ProductCardUnavailableProps
  extends Omit<
    ProductCardProps,
    | 'onChangeQuantity'
    | 'trackProductsOriginClick'
    | 'badges'
    | 'quantity'
    | 'totalPrice'
    | 'unitPrice'
  > {
  onClickRemind: VoidFunction;
}

export const ProductCardUnavailable: React.FC<ProductCardUnavailableProps> = ({
  className,
  product,
  wishlistButton,
  additionalBadge,
  deleteBlock,
  onClickRemind,
  trackProductClick,
  openInNewTab,
}) => {
  const {t} = useTranslation();
  return (
    <ProductCardBase
      className={className}
      imageBlock={
        <ProductCardImage
          product={product}
          badges={null}
          wishlistButton={wishlistButton}
          trackProductClick={trackProductClick}
          overlayComponent={
            <SoldOutWrapper>{t('Unfortunately missed')}</SoldOutWrapper>
          }
          openInNewTab={openInNewTab}
        />
      }
      descriptionBlock={
        <ProductCardDescription
          product={product}
          quantity={{
            quantity: 0,
            maxQuantity: 0,
          }}
          trackProductClick={trackProductClick}
          additionalBadge={additionalBadge}
          openInNewTab={openInNewTab}
        />
      }
      quantityBlock={
        <Button
          data-testid="remindUnavailableProductButton"
          onClick={onClickRemind}
          aria-label={undefined}
          variant="secondary"
        >
          <Icon size={'XS'} asset={GenericIconName.MailBlack} />
          {t('Notify me when this is available')}
        </Button>
      }
      deleteBlock={deleteBlock}
      priceBlock={null}
    />
  );
};

const SoldOutWrapper = styled.div`
  background-color: rgba(245, 245, 245, 0.8);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  text-align: center;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  color: ${COLORS.Black};
`;
